import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Timestamp } from 'firebase/firestore';
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useUser } from '../../../lib/hooks/use-user';
import { useVisit } from '../../../lib/hooks/use-visits';

type VisitParams = 'id';

const SiteVisitStep4 = (props) => {
  const { id } = useParams<VisitParams>();
  const navigate = useNavigate();

  useEffect(() => {}, []);

  if (props.currentStep !== 4) return null;
  return (
    <>
      <div className="grid grid-cols-9 col-span-9 ">
        <div className="grid grid-cols-9 col-span-9 content-center ">
          <p className={'col-span-9 text-center mt-4 mb-4 font-semibold'}>
            Overview
          </p>
          <p className={'col-span-7 col-start-2 pl-4 text-left font-bold mb-1'}>
            Required
          </p>
          <p
            className={
              'col-span-7 col-start-2 pl-4 text-left mb-2 font-normal cursor-pointer'
            }
            onClick={() => props.changeStep(1)}
          >
            {props.step1Done && <input type="checkbox" checked />}{' '}
            {!props.step1Done && <input type="checkbox" />} Site Visit Basics{' '}
            <FontAwesomeIcon icon={faAngleRight} />
          </p>
          <p
            className={
              'col-span-7 col-start-2 pl-4 text-left mb-2 font-normal cursor-pointer'
            }
            onClick={() => props.changeStep(2)}
          >
            {props.step2Done && <input type="checkbox" checked />}
            {!props.step2Done && <input type="checkbox" />} Technical assistance{' '}
            <FontAwesomeIcon icon={faAngleRight} />
          </p>
          <p className={'col-span-7 col-start-2 pl-4 text-left font-bold mb-1'}>
            Optional
          </p>
          <p
            className={
              'col-span-7 col-start-2 pl-4 text-left mb-2 font-normal cursor-pointer'
            }
            onClick={() => props.changeStep(4)}
          >
            {props.step3Done && <input type="checkbox" checked />}{' '}
            {!props.step3Done && <input type="checkbox" />} Place Lead{' '}
            <FontAwesomeIcon icon={faAngleRight} />
          </p>
        </div>
      </div>
    </>
  );
};

export default SiteVisitStep4;
